import { IFormMetricsRanking } from "../../models/input/surveyApi/IValuesMetrics";
import * as ApiWithToken from "../callApiWithToken";

const rankingMetricService = {
  GetRankingMetricList: async function (languageId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_SURVEY_API +
        `RankingMetrics/GetRankingMetricList?languageId=${languageId}`
    );
  },
  GetRankingMetrics: async function (
    form: IFormMetricsRanking
  ) {
    let url =
      process.env.REACT_APP_SURVEY_API +
      `RankingMetrics/${form.TypeRanking}?startDate=${form.StartDate}&endDate=${form.EndDate}`;

    if (form.Country !== undefined) {
      url += `&countryId=${form.Country}`;
    }
    return ApiWithToken.getApi(url);
  },
};
export default rankingMetricService;
